import React from 'react'


import {
  Card,
  ErrorBoundary,
  SimpleCollapse
} from 'components'
import { useGet } from 'hooks'
import { useForm, FormProvider } from 'react-hook-form'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import { IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse } from 'services/GST/GraduacaoMultas'
import { SPACING } from 'utils'

import Form from './components/Form'
import TableHistoricoValorUnidadeUFIR from './components/TableHistoricoValorUnidadeUFIR'
import { IForm } from './types'

const AddUFIRValue: React.FC = () => {
  const methods = useForm<IForm>()
  const {
    data,
    refresh: refreshTableHistoricoValorUnidadeUFIR,
    handleChangePage,
    handleChangeRowsPerPage,
    page,
    rowsPerPage
  } = useGet<{}, IPaginatedEntityGST<IGraduacaoMultasGetAllHistoricoValorUnidadeUFIRResponse[]>>({
    api: 'Gst',
    isPaginated: true,
    params: {},
    url: 'Ufir'
  })

  return (
    <FormProvider {...methods}>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <Form
          refreshTable={refreshTableHistoricoValorUnidadeUFIR}
        />
        <SimpleCollapse isExpanded title="Historico Valor Unidade UFIR">
          <ErrorBoundary>
            <TableHistoricoValorUnidadeUFIR
              data={data}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
            />
          </ErrorBoundary>
        </SimpleCollapse>
      </Card>
    </FormProvider>
  )
}

export default AddUFIRValue
